export default {
  buy: 'Comprar',
  locked_title: 'Recurso não contratado',
  locked_hint: 'Este recurso não faz parte do seu plano atual.',
  banner_overdue: 'Pagamento em atraso — seu acesso continua por carência.',
  banner_overdue_until: ' Regularize até {date} para não perder o acesso.',
  banner_courtesy: 'Você está em período de cortesia.',
  banner_courtesy_until: ' Acesso garantido até {date}.',
  blocked: {
    suspended: {
      title: 'Conta suspensa por falta de pagamento',
      body: 'Seu acesso foi pausado após o fim da carência. Regularize o pagamento para reativar o rastreamento — seus dados e histórico estão preservados.',
    },
    frozen: {
      title: 'Conta temporariamente bloqueada',
      body: 'Esta conta foi suspensa pela nossa equipe. Se você acredita que é um engano, fale com o suporte.',
    },
    canceled: {
      title: 'Assinatura encerrada',
      body: 'O período contratado terminou e a assinatura foi cancelada. Contrate novamente para voltar a rastrear.',
    },
    overdue: {
      title: 'Pagamento pendente',
      body: 'Não conseguimos confirmar seu pagamento. Regularize para continuar usando o rastreamento.',
    },
    pending: {
      title: 'Pagamento aguardando confirmação',
      body: 'Sua cobrança ainda não foi confirmada. Pague o PIX/fatura abaixo — assim que confirmar, o painel é liberado.',
    },
    no_service: {
      title: 'Nenhum serviço contratado',
      body: 'Esta conta ainda não tem um serviço ativo. Contrate um plano para liberar o painel de rastreamento.',
    },
  },
  contracted: {
    title: 'Contratado × ativo',
    usage_of: '{used} de {limit} ativos',
    res: {
      tags: 'Tags',
      mobile: 'Celulares',
      geofences: 'Cercas',
      members: 'Usuários',
    },
  },
  pay: {
    title: 'Cobrança em aberto',
    due: 'Vencimento: {date}',
    qr_alt: 'QR Code PIX da cobrança',
    copy: 'Copiar código PIX',
    copied: 'Copiado!',
    open_invoice: 'Abrir fatura',
    open_boleto: 'Abrir boleto',
    i_paid: 'Já paguei — atualizar',
    none: 'Nenhuma cobrança em aberto no momento.',
    owner_hint: 'Somente o responsável pela conta pode ver e pagar a cobrança.',
  },
  contract: {
    title: 'Você ainda não tem um serviço',
    body: 'Para usar o painel LOCZI, contrate um plano ou produto — leva só alguns minutos.',
    cta: 'Contratar um serviço',
    reload: 'Já contratei — atualizar',
  },
  blocked_pay: 'Regularizar pagamento',
  blocked_support: 'Falar com o suporte',
  terms_title: 'Termos atualizados',
  terms_body: 'Publicamos uma nova versão dos documentos abaixo. Para continuar usando a plataforma, leia e aceite.',
  terms_agree: 'Li e aceito os documentos listados acima.',
  terms_confirm: 'Continuar',
  limit_reached: 'Limite do plano atingido',
  mobile_limit_hint: 'Você já usou todas as licenças de celular do plano. Compre mais licenças para parear outro aparelho.',
  tag_limit_hint: 'Você já usou todas as tags do plano. Adquira mais tags para continuar.',
  geofence_limit_hint: 'Limite de cercas do plano atingido.',
  buy_more: 'Comprar mais',
}
